var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgReorder = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18.115,
      height: 23,
      viewBox: "0 0 18.115 23",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_18200",
      "data-name": "Group 18200",
      transform: "translate(-151.795 -483.501)"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_76574",
      "data-name": "Rectangle 76574",
      width: 18.115,
      height: 3.916,
      rx: 1,
      transform: "translate(151.795 489.939)"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_76575",
      "data-name": "Rectangle 76575",
      width: 18.115,
      height: 3.916,
      rx: 1,
      transform: "translate(151.795 496.078)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22216",
      "data-name": "Path 22216",
      d: "M8450.511,223.185,8448.6,226.5a.52.52,0,0,0,.45.781h3.827a.521.521,0,0,0,.451-.781l-1.914-3.314A.52.52,0,0,0,8450.511,223.185Z",
      transform: "translate(-8290.187 260.576)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22217",
      "data-name": "Path 22217",
      d: "M8451.412,479.19l1.914-3.314a.52.52,0,0,0-.451-.781h-3.827a.52.52,0,0,0-.45.781l1.913,3.314A.52.52,0,0,0,8451.412,479.19Z",
      transform: "translate(-8290.187 27.051)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgReorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Reorder.73d74a68.svg";
export { ForwardRef as ReactComponent };